import axios from "axios";
import commons from "./index";

export default {
  shipment: {
    update: (id, shipment) => {
      return axios.put(`${commons.apiURL}/api/v1/shipments/${id}`, shipment);
    },
    getByID: id => {
      return axios.get(`${commons.apiURL}/api/v1/shipments/${id}`);
    },
    searchByKeyword(userID, query) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all/${userID}/query?filter=${query}`
      );
    },
    filterByGuideStatus(userID, status) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all/${userID}/guide?status=${status}`
      );
    },
    getAvailableCarriers(userID) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all/${userID}/carrier-services`
      );
    },
    getAllAvailableCarriers(userID) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all-carrier-services`
      );
    },
    filterShipmentsByCarriersServices(userID, criteria) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all/${userID}/carrier?name=${criteria}`
      );
    },
    getLastShipments(user_id) {
      return axios.get(`${commons.apiURL}/api/v1/last/shipment/${user_id}`);
    },
    getStatusGuide(user_id) {
      return axios.get(`${commons.apiURL}/api/v1/status/guide/${user_id}`);
    },
    getParcels(user_id) {
      return axios.get(`${commons.apiURL}/api/v1/parcels/${user_id}`);
    },
    filterShipment(user_id, query) {
      return axios.get(
        `${commons.apiURL}/api/v1/shipments/all/${user_id}/filter?q=${query}`
      );
    },
    getPostalCodes: (country, postal_code) => {
      return axios.get(
        `${commons.apiURL}/api/v1/postalcodes/${country}/${postal_code}`
      );
    },
    getPaypalLink: _id => {
      return axios.get(`${commons.apiURL}/api/v1/paypal/plus/link/${_id}`);
    },
    generateGuidesAfterPay: _id => {
      return axios.get(
        `${commons.apiURL}/api/v1/generate-guides-after-pay/${_id}`
      );
    },
    generateGuidesAfterPayMany: (email, user, shipments) => {
      return axios.post(
        `${commons.apiURL}/api/v1/generate-guides-after-pay/many`,
        {
          email,
          user,
          shipments
        }
      );
    },
    executePayment: (payment_id, payer_id, shipment_id, email) => {
      return axios.post(`${commons.apiURL}/api/v1/paypal/payment/execute`, {
        payment_id: payment_id,
        payer_id: payer_id,
        shipment_id: shipment_id,
        email: email
      });
    },
    executeManyPayment: (payment_id, payer_id, shipments, email) => {
      return axios.post(
        `${commons.apiURL}/api/v1/paypal/payment/many/execute`,
        {
          payment_id: payment_id,
          payer_id: payer_id,
          shipments: shipments,
          email: email
        }
      );
    }
  },
  prepaid: {
    getPaypalLink: _id => {
      console.log("getLinkPayPalPlus");
      return axios.get(
        `${commons.apiURL}/api/v1/prepaid/getLinkPayPalPlus/${_id}`
      );
    },
    executePayment: (payment_id, payer_id, prepaid_id, email) => {
      return axios.post(
        `${commons.apiURL}/api/v1/prepaid/paypalPaymentExecute`,
        {
          payment_id: payment_id,
          payer_id: payer_id,
          prepaid_id: prepaid_id,
          email: email
        }
      );
    },
    paymentPrepaidExecute: _id => {
      return axios.get(
        `${commons.apiURL}/api/v1/prepaid/v2/execute-prepaid/${_id}`
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/commons/api.js